import React, { useState, useEffect } from "react";
import Icon1 from "../images/icon1.png";
import Icon3 from "../images/icon3.png";
import Icon2 from "../images/icon2.png";
import Icon4 from "../images/Account-cash.png";
import Icon5 from "../images/dividends.png";
import Icon6 from "../images/Account-Realized-gain.png";
import { useNavigate } from 'react-router-dom';
import callingAPI from "../service"

export default function DashboardAccountInfo({ dashboardAccountDataInfo }) {
    console.log("🚀 ~ DashboardAccountInfo ~ dashboardAccountDataInfo:", dashboardAccountDataInfo)
    useEffect(() => {

    }, [])





    return (
        <div className="value-cards">
            <div className="cards-sub">
                <div className="img-cards">
                    <img src={Icon2} alt="Icon1" className="img-fluid" width="50" height="50" />
                </div>
                <div className="card-content">
                    <div className="cards-name">
                        Account Value
                    </div>
                    <div className="d-flex  align-items-center gap-2">

                        <div className="cards-price">
                            {dashboardAccountDataInfo.accountValue !== undefined && (
                                <span className={Number(dashboardAccountDataInfo.accountValue) < 0 ? 'text-danger' : ''}>
                                    {Number(dashboardAccountDataInfo.accountValue) < 0
                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(dashboardAccountDataInfo.accountValue)))})`
                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(dashboardAccountDataInfo.accountValue))}
                                </span>
                            )}
                        </div>
                        <div className="price-digit">
                            AED
                        </div>
                    </div>
                </div>
            </div>
            <div className="cards-sub">
                <div className="img-cards">
                    <img src={Icon3} alt="Icon1" className="img-fluid" width="50" height="50" />
                </div>
                <div className="card-content">
                    <div className="cards-name">
                        Account Equity Value
                    </div>
                    <div className="d-flex  align-items-center gap-2">

                        <div className="cards-price">
                            {dashboardAccountDataInfo.accountEquityValue !== undefined && (
                                <span className={Number(dashboardAccountDataInfo.accountEquityValue) < 0 ? 'text-danger' : ''}>
                                    {Number(dashboardAccountDataInfo.accountEquityValue) < 0
                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(dashboardAccountDataInfo.accountEquityValue)))})`
                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(dashboardAccountDataInfo.accountEquityValue))}
                                </span>
                            )}
                        </div>
                        <div className="price-digit">
                            AED
                        </div>
                    </div>
                </div>
            </div>
            <div className="cards-sub">
                <div className="img-cards">
                    <img src={Icon1} alt="Icon1" className="img-fluid " width="50" height="50" />
                </div>
                <div className="card-content">
                    <div className="cards-name">
                        Account Buying Power
                    </div>
                    <div className="d-flex  align-items-center gap-2">

                        <div className="cards-price">
                            {dashboardAccountDataInfo.accountBuyingPower !== undefined && (
                                <span className={Number(dashboardAccountDataInfo.accountBuyingPower) < 0 ? 'text-danger' : ''} >
                                    {Number(dashboardAccountDataInfo.accountBuyingPower) < 0
                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(dashboardAccountDataInfo.accountBuyingPower)))})`
                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(dashboardAccountDataInfo.accountBuyingPower))}
                                </span>
                            )}
                        </div>
                        <div className="price-digit">
                            AED
                        </div>
                    </div>
                </div>
            </div>
            <div className="cards-sub">
                <div className="img-cards">
                    <img src={Icon4} alt="Icon1" className="img-fluid" width="50" height="50" />
                </div>
                <div className="card-content">
                    <div className="cards-name">
                        Account cash
                    </div>
                    <div className="d-flex  align-items-center gap-2">

                        <div className="cards-price">
                            {dashboardAccountDataInfo.accountCash !== undefined && (
                                <span className={Number(dashboardAccountDataInfo.accountCash) < 0 ? 'text-danger' : ''} >
                                    {Number(dashboardAccountDataInfo.accountCash) < 0
                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(dashboardAccountDataInfo.accountCash)))})`
                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(dashboardAccountDataInfo.accountCash))}
                                </span>
                            )}
                        </div>
                        <div className="price-digit">
                            AED
                        </div>
                    </div>
                </div>
            </div>
            {/* commended  Account Dividends - YTD as per sajeev requirement on 12 march conversation */}
            {/* <div className="cards-sub">
                <div className="img-cards">
                    <img src={Icon5} alt="Icon1" className="img-fluid" width="50" height="50" />
                </div>
                <div className="card-content">
                    <div className="cards-name">
                        Account Dividends - YTD
                    </div>
                    <div className="d-flex  align-items-center gap-2">

                        <div className="cards-price">
                            {dashboardAccountDataInfo.accountDividends !== undefined && (
                                <span className={Number(dashboardAccountDataInfo.accountDividends) < 0 ? 'text-danger' : ''} >
                                    {Number(dashboardAccountDataInfo.accountDividends) < 0
                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(dashboardAccountDataInfo.accountDividends)))})`
                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(dashboardAccountDataInfo.accountDividends))}
                                </span>
                            )}
                        </div>
                        <div className="price-digit">
                            AED
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="cards-sub">
                <div className="img-cards">
                    <img src={Icon6} alt="Icon1" className="img-fluid" width="50" height="50" />
                </div>
                <div className="card-content">
                    <div className="cards-name">
                        Account Realized gain
                        /(Loss)-YTD
                    </div>
                    <div className="d-flex  align-items-center gap-2">

                        <div className="cards-price cards-price-green">
                            {dashboardAccountDataInfo.accountRealizedGain !== undefined && (
                                <span className={Number(dashboardAccountDataInfo.accountRealizedGain) < 0 ? 'text-danger' : ''}>
                                    {Number(dashboardAccountDataInfo.accountRealizedGain) < 0
                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(dashboardAccountDataInfo.accountRealizedGain)))})`
                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(dashboardAccountDataInfo.accountRealizedGain))}
                                </span>
                            )}
                        </div>
                        <div className="price-digit">
                            AED
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}